module.exports = __webpack_public_path__ + "images/navigation/black-wide-e002b87c.jpg";